export default {
    state: {},
    getters: {},
    mutations: {},
    actions: {
        getAboutUsContent() {
            return new Promise((resolve, reject) => {
                window.axios.get("/setting/about_us")
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        updateAboutUs(_, data) {
            return new Promise((resolve, reject) => {
                window.axios.post("/admin/setting/about_us", data)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        }
    },
}

